import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

import {
  computed,
  withDefaults,
  ref,
  onMounted,
  onUnmounted,
} from 'vue';
import SwWorkCard from '@/components/organisms/Cards/SwWorkCard.vue';
import { Productions } from '@/api/spotwrite';
import { WorkRouteRecordNameType } from '@/types/ui-components';

interface Props {
  items?: Productions[];
  cols?: number;
  columnGap?: number;
  rowGap?: number;
  showRank?: boolean;
  routeRecordName?: WorkRouteRecordNameType;
  hideStatus?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SwWorksSection',
  props: {
    items: { default: undefined },
    cols: { default: 3 },
    columnGap: { default: 15 },
    rowGap: { default: 15 },
    showRank: { type: Boolean, default: false },
    routeRecordName: { default: 'workDetail' },
    hideStatus: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { items: Productions[], cols: number, columnGap: number, rowGap: number, showRank: boolean, routeRecordName: WorkRouteRecordNameType, hideStatus: boolean }



/**
 * コンテナ element
 */
const containerElement = ref<HTMLDivElement>();
const containerWidth = ref(0);

/**
 * cols と gap から、itemの幅を計算して返します。
 */
const itemWidth = computed(() => {
  if (!containerWidth.value) return undefined;

  const totalGap = (props.cols - 1) * props.columnGap;
  const width = Math.floor((containerWidth.value - totalGap) / props.cols);
  return width;
});

/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-works-section': true,
}));

/**
 * container の style 属性
 */
const containerStyles = computed(() => {
  const styles = [
    `gap: ${props.columnGap}px`,
    `row-gap: ${props.rowGap}px`,
  ];
  return styles.join(';');
});

/**
 * item の style 属性
 */
const itemStyles = computed(() => {
  const styles = [
    `width: ${itemWidth.value}px`,
  ];
  return styles.join(';');
});

/**
 * Windowサイズ変更時
 */
const onResize = () => {
  let width = 0;
  if (containerElement.value) {
    const { clientWidth } = containerElement.value;
    width = clientWidth;
  }
  containerWidth.value = width;
};

onMounted(() => {
  onResize();
  window.addEventListener('resize', onResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', onResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("div", {
      ref_key: "containerElement",
      ref: containerElement,
      class: "sw-works-section--items",
      style: _normalizeStyle(_unref(containerStyles))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createBlock(SwWorkCard, {
          class: "sw-works-section--items-item",
          style: _normalizeStyle(_unref(itemStyles)),
          key: item.id,
          "thumb-width": _unref(itemWidth),
          "route-record-name": __props.routeRecordName,
          rank: __props.showRank ? index + 1 : undefined,
          item: item,
          "hide-status": __props.hideStatus
        }, null, 8, ["style", "thumb-width", "route-record-name", "rank", "item", "hide-status"]))
      }), 128))
    ], 4)
  ], 2))
}
}

})